export default __webpack_public_path__ + "static/media/gameover.3c5ebcee.jpg";